/** 兼容性封装（结合 execCommand 和 clipboard） */
export const copy = async (text) => {
    if (navigator.clipboard) {
        try {
            await navigator.clipboard.writeText(text);
            return true;
        } catch (err) {
            console.error('Modern API 复制失败:', err);
        }
    }

    // 回退到 execCommand
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed'; // 避免滚动
    document.body.appendChild(textarea);
    textarea.select();
    try {
        const success = document.execCommand('copy');
        document.body.removeChild(textarea);
        return success;
    } catch (err) {
        console.error('execCommand 复制失败:', err);
        document.body.removeChild(textarea);
        return false;
    }
}
//图片下载
// 使用示例 downloadImage('https://example.com/image.jpg', 'my-image.jpg');
export const downloadImage = (url, filename) => {
    const a = document.createElement('a');
    a.href = url;
    a.download = filename || 'downloaded-image.jpg';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}

//比较工具，看看2个文本那个地方有问题
export const findDifferences = (str1, str2) => {
    const minLength = Math.min(str1.length, str2.length);
    const diffs = [];

    for (let i = 0; i < minLength; i++) {
        if (str1[i] !== str2[i]) {
            diffs.push({
                position: i,
                char1: str1[i],
                char2: str2[i]
            });
        }
    }

    return diffs.length ? diffs : '完全一致';
}